export class PrioridadAccion {
  ID: number;
  NOMBRE: string;
}
